import { createAction } from '@reduxjs/toolkit';
import { Asset, LoadFavoritesReturn } from '../../api';
import { Loading, LoadingMode } from '../finder/model';

export const assetsChanged = createAction<
  { data: LoadFavoritesReturn; hasNextPage: boolean; scrollHash: string },
  'al/favorite/assetsChanged'
>('al/favorite/assetsChanged');

export const thumbnailUpdated = createAction<{ assetId: Asset['id']; url: Asset['thumbnail_url'] }>(
  'al/favorite/thumbnailUpdated',
);

export const setLoading = createAction<{ loading: Loading }, 'al/favorite/setLoading'>(
  'al/favorite/setLoading',
);

export const loadFavoritesRequested = createAction<
  { mode: LoadingMode },
  'al/favorite/loadFavoritesRequested'
>('al/favorite/loadFavoritesRequested');

export const assetsToggled = createAction<
  { add: boolean; assets?: Asset[]; selectAll?: boolean },
  'al/favorite/assetsToggled'
>('al/favorite/assetsToggled');

export const setInProgress = createAction<
  { ids: Asset['id'][]; inProgress: boolean },
  'al/favorite/setInProgress'
>('al/favorite/setInProgress');

export const setAllInProgress = createAction<
  { allInProgress: boolean },
  'al/favorite/setAllInProgress'
>('al/favorite/setAllInProgress');

export const clearFavoritesClicked = createAction<void, 'al/favorite/clearFavoritesClicked'>(
  'al/favorite/clearFavoritesClicked',
);
